export default __webpack_public_path__ + "static/media/dtla.2c145c01.png";